import { useCallback } from 'react';
import ReactGA from 'react-ga4';

export type GAEventParams = Record<string, string | number | boolean>;

export const useGATracking = () => {
	const sendEvent = useCallback((event: string, params?: GAEventParams) => {
		ReactGA.event(event, params);
	}, []);

	return { sendEvent };
};

export default useGATracking;
